module.exports = __webpack_public_path__ + "static/media/2.17f799f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/infocast/2.jpg
// module id = 478
// module chunks = 0